module.exports = "<main>\n  <section>\n      <figure class=\"img-arrow\">\n        <img src=\"./assets/images/arrow.png\">\n      </figure>\n      <h1>Find your artist below</h1>\n      <button class=\"btn\" (click)=\"openModal()\">\n        Search Artist\n      </button>\n  </section>\n  <app-modal *ngIf=\"showModal\" (close)=\"showModal = false\"></app-modal>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main